import * as React from "react";

import { Button } from "src/library/components/Button";
import { Text } from "src/library/components/Text/Text";
import useDrop from "src/core/drops/hooks/useDrop";
import { poNumberIsValid } from "src/core/orders/utils/orders";

import { StyledInput } from "../InputFields";
import { TPurchaseOrderNumberType } from "./PurchaseOrderNumberTypes";

interface IProps {
  isEditable: boolean;
  type: TPurchaseOrderNumberType;
  customerReference?: string;
  setPONumber: (PONumber: string) => void;
}

const EditPurchaseOrderNumber: React.ReactFCWithChildren<IProps> = ({
  isEditable, customerReference, setPONumber
}) => {
  const [ canEditPONumber, setCanEditPONumber ] = React.useState<boolean>(false);
  const [ editPONumber, setEditPONumber ] = React.useState<boolean>(false);
  const [ poNumber, setLocalPONumber ] = React.useState<string | undefined>(undefined);
  const [ poError, setPOError ] = React.useState<string | null>(null);
  const [ { drop } ] = useDrop();

  const updatePONumber = () => {
    if (poNumber) {
      setEditPONumber(false);
      setPONumber(poNumber);
    }
  };

  React.useEffect(() => {
    if (customerReference && !poNumber) {
      setLocalPONumber(customerReference);
    }
  }, []);

  React.useEffect(() => {
    setCanEditPONumber(isEditable);
  }, [ isEditable ]);

  return (
    <div>
      {!canEditPONumber ? (
        <>
          {poNumber}
        </>
      ) : (
        <>
          {editPONumber ? (
            <>
              <StyledInput
                onChange={e => {
                  setLocalPONumber(e.target.value);

                  if (drop) {
                    const poNumberError = poNumberIsValid(e.target.value, drop);

                    setPOError(poNumberError);
                  }
                }}
                value={poNumber}
              />

              {poError && (
                <Text color="error">
                  {poError}
                </Text>
              )}

              <Button
                loading={false}
                onClick={() => updatePONumber()}
                disabled={!!poError}
              >
                Confirm
              </Button>
            </>
          ) : (
            <>
              {poNumber}

              <Button
                loading={false}
                onClick={() => setEditPONumber(true)}
              >
                Edit
              </Button>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default EditPurchaseOrderNumber;
